import {texture} from "p3";
import definitions from "../../../definitions";
import NPC from "./NPC";

export default class NPCPrincessSvandelyne extends NPC {
    constructor() {
        super(definitions.NPC_ID.PRINCESS_SVANDELYNE);

        this.collisionRadius = 26;
        this.collisionOffsetX = 0;
        this.collisionOffsetY = -26;
    }

    init() {
        super.init();

        this.addViewWithTexture(texture("char_princess_svendolyne_idle_00"));

        this.addShadow(definitions.SHADOW_SIZE.LARGE, 0.6, new PIXI.Point(0, -6));
        this.animateIdle(0.4);
    }
}